import { c as _c } from "react/compiler-runtime";
import { AboutLocalInfo } from "@components/header/about-local-info";
import { Box, Stack } from "@mui-wrapper";
import { DevFeaturesPanel } from "@components/dev-features-dialog/dev-features-panel";

/**
 * Content for the Dev Features Dialog.
 * Displays the features/tools table and app version info.
 */
export function DevFeaturesDialogContent() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      py: 2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DevFeaturesPanel />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={t0}><Stack spacing={2}>{t1}<Box sx={{
          mt: 0.25
        }}><AboutLocalInfo /></Box></Stack></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}